<template>
  <div>
    <div class="firstInterviewPartB" v-if="version">
      <!-- 注释  -->
      <div v-if="version == 1">
        <div class="evaluationPeport_main">
        <div>
          <div class="title">
          {{studentName}}生涯测评报告
        </div>
        <div>
          <div class="partTitle">人格特性</div>
            <Rgtx v-if="reportId" :reportId="reportId"></Rgtx>
        </div>
        <div class="buchongs">
          <span :style="{display:show?'':'none'}"></span>
          <a :style="{display:show?'':'none'}">报告解读：</a>
          <div class="textare">
            <el-input
                placeholder="咨询师解读"
                :disabled="show"
                type="textarea"
                maxlength="200"
                show-word-limit
                v-model="rgtx" >
            </el-input>
          </div>
        </div>
        <div>
          <div class="partTitle">智能水平</div>
          <Rzqn v-if="reportId" :reportId="reportId"></Rzqn>
        </div>
        <div class="buchongs">
          <span :style="{display:show?'':'none'}"></span>
          <a :style="{display:show?'':'none'}">报告解读：</a>
          <div class="textare">
            <el-input
                placeholder="咨询师解读"
                :disabled="show"
                type="textarea"
                maxlength="200"
                show-word-limit
                v-model="rzqn" >
            </el-input>
          </div>
        </div>
        <div>
          <div class="partTitle">兴趣倾向</div>
          <Xqqx v-if="reportId" :reportId="reportId"></Xqqx>
        </div>
        <div class="buchongs">
          <span :style="{display:show?'':'none'}"></span>
          <a :style="{display:show?'':'none'}">报告解读：</a>
          <div class="textare">
            <el-input
                placeholder="咨询师解读"
                :disabled="show"
                type="textarea"
                maxlength="200"
                show-word-limit
                v-model="xqqx" >
            </el-input>
          </div>
        </div>
        <div>
          <div class="partTitle">职业价值观</div>
          <Zysy v-if="reportId" :reportId="reportId"></Zysy>
        </div>
        <div class="buchongs">
          <span :style="{display:show?'':'none'}"></span>
          <a :style="{display:show?'':'none'}">报告解读：</a>
          <div class="textare">
            <el-input
                placeholder="咨询师解读"
                :disabled="show"
                type="textarea"
                maxlength="200"
                show-word-limit
                v-model="zysy" >
            </el-input>
          </div>
        <div>
          <div class="partTitle">心理适应性</div>
          <Xljk v-if="reportId" :reportId="reportId"></Xljk>
        </div>
        <div class="buchongs">
            <span :style="{display:show?'':'none'}"></span>
            <a :style="{display:show?'':'none'}">报告解读：</a>
            <div class="textare">
              <el-input
                  placeholder="咨询师解读"
                  :disabled="show"
                  type="textarea"
                  maxlength="200"
                  show-word-limit
                  v-model="xljk" >
              </el-input>
            </div>
        </div>
        <div>
          <div class="partTitle">
            匹配职业与专业
          </div>
          <Zyzytj v-if="reportId" :reportId="reportId" @event="getTuijianData($event)" type="1"></Zyzytj>
          <div class="buchongs">
            <span :style="{display:show?'':'none'}"></span>
            <a :style="{display:show?'':'none'}">报告解读：</a>
            <div class="textare">
              <el-input
                  placeholder="咨询师解读"
                  :disabled="show"
                  type="textarea"
                  maxlength="200"
                  show-word-limit
                  v-model="zyzyOne" >
              </el-input>
            </div>
          </div>
        </div>
        <div>
          <div class="partTitle">
            匹配职业与专业
          </div>
          <Zyzytj v-if="reportId" :reportId="reportId" type="2"></Zyzytj>
          <div class="buchongs">
            <span :style="{display:show?'':'none'}"></span>
            <a :style="{display:show?'':'none'}">报告解读：</a>
            <div class="textare">
              <el-input
                  placeholder="咨询师解读"
                  :disabled="show"
                  type="textarea"
                  maxlength="200"
                  show-word-limit
                  v-model="zyzyTwo" >
              </el-input>
            </div>
          </div>
        </div>
        <div>
          <div class="partTitle">
            匹配职业与专业
          </div>
          <Zyzytj v-if="reportId" :reportId="reportId" type="3"></Zyzytj>
          <div class="buchongs">
            <span :style="{display:show?'':'none'}"></span>
            <a :style="{display:show?'':'none'}">报告解读：</a>
            <div class="textare">
              <el-input
                  placeholder="咨询师解读"
                  :disabled="show"
                  type="textarea"
                  maxlength="200"
                  show-word-limit
                  v-model="zyzyThree" >
              </el-input>
            </div>
          </div>
        </div>
          <div>
            <div class="yixiang">
              <span></span>学生意向:
              <div class="con">
                <div>
                  <span>学生向往的职业 :</span>
                  {{students.myLikeCareer}}
                </div>
                <div>
                  <span>未来想过的生活 :</span>
                  {{students.myWantLife}}
                </div>
                <div>
                  <span>母亲职业 :</span>
                  {{students.motherWork}}
                </div>
                <div>
                  <span>父亲职业 :</span>
                  {{students.fatherWork}}
                </div>
                <div>
                  <span style="position:relative;top:-80px">家长意见 :</span>
                  <div class="innerDiv">
                    理想专业（方向）： {{parents.futureMajor}} <br/>
                    理想大学（城市）： {{parents.futureUniversity}}<br/>
                    高考路径 （升学）：{{parents.futureEducation}}
                  </div>
                </div>
                <div>
                  <span>家长访谈记录 :</span>
                  {{interview}}
                </div>
              </div>
            </div>
            <div style="margin-top: 20px;line-height: 34px" class="changeTj">
              目标职业领域（单选）：&nbsp;&nbsp;
              <div style="display: inline-block">
                <el-radio-group v-model="targetCareerField" :disabled="show">
                  <el-radio   :label="best.name" @click.native.prevent="radioChild(1)">{{best.name}}</el-radio>
                  <el-radio   :label="second.name" @click.native.prevent="radioChild(2)">{{second.name}}</el-radio>
                  <el-radio   :label="third.name" @click.native.prevent="radioChild(3)">{{third.name}}</el-radio>
                  <el-radio   label="没有适合的职业领域" @click.native.prevent="radioChild(4)">没有适合的职业领域</el-radio>
                </el-radio-group>
                <el-select v-model="selectDataNumber"  :disabled="show" v-if="selectBool" @change="selectChange" placeholder="请选择">
                  <el-option
                      v-for="(item,key) in careerMajors"
                      :key="item.name"
                      :label="item.name"
                      :value="key">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div style="margin-top: 20px" class="changeTj">
              目标职业：&nbsp;&nbsp;
              <div style="padding-left: 100px;">
                <el-checkbox-group
                    v-model="targetCareer"
                    :disabled="show"
                    :max="3">
                  <el-checkbox v-for="(item,key) in tuijianData.careers||[]" :label="item.name" :key="key">{{item.name}}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <div style="margin-top: 20px" class="changeTj">
              目标专业：&nbsp;&nbsp;
              <div style="padding-left: 100px;">
                <el-checkbox-group
                    v-model="targetSubject"
                    :disabled="show"
                    :max="3">
                  <el-checkbox v-for="(item,key) in tuijianData.majors||[]" :label="item.name" :key="key">{{item.name}}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
      </div>
      <div v-if="version == 2">
        <div class="evaluationPeport_main">
        <div class="title">
          {{studentName}}生涯测评报告
        </div>
        <div>
          <div class="partTitle">人格特性</div>
          <keep-alive>
            <Rgtx2 :mbti="mbti"></Rgtx2>
          </keep-alive>
        </div>
        <div class="buchongs">
          <span :style="{display:show?'':'none'}"></span>
          <a :style="{display:show?'':'none'}">报告解读：</a>
          <div class="textare">
            <el-input
                placeholder="咨询师解读"
                :disabled="show"
                type="textarea"
                maxlength="200"
                show-word-limit
                v-model="rgtx" >
            </el-input>
          </div>
        </div>
        <div>
          <div class="partTitle">智能水平</div>
          <keep-alive>
            <Znsp2 :intelligent="intelligent"></Znsp2>
          </keep-alive>
        </div>
        <div class="buchongs">
          <span :style="{display:show?'':'none'}"></span>
          <a :style="{display:show?'':'none'}">报告解读：</a>
          <div class="textare">
            <el-input
                placeholder="咨询师解读"
                :disabled="show"
                type="textarea"
                maxlength="200"
                show-word-limit
                v-model="rzqn" >
            </el-input>
          </div>
        </div>
        <div>
          <div class="partTitle">兴趣倾向</div>
          <keep-alive>
            <Xqqx2 :hobby="hobby"></Xqqx2>
          </keep-alive>
        </div>
        <div class="buchongs">
          <span :style="{display:show?'':'none'}"></span>
          <a :style="{display:show?'':'none'}">报告解读：</a>
          <div class="textare">
            <el-input
                placeholder="咨询师解读"
                :disabled="show"
                type="textarea"
                maxlength="200"
                show-word-limit
                v-model="xqqx" >
            </el-input>
          </div>
        </div>
        <div>
          <div class="partTitle" style="margin-top: 20px">职业价值观</div>
          <keep-alive>
            <Zyjzg2 :profession="profession"></Zyjzg2>
          </keep-alive>
        </div>
        <div class="buchongs">
          <span :style="{display:show?'':'none'}"></span>
          <a :style="{display:show?'':'none'}">报告解读：</a>
          <div class="textare">
            <el-input
                placeholder="咨询师解读"
                :disabled="show"
                type="textarea"
                maxlength="200"
                show-word-limit
                v-model="zysy" >
            </el-input>
          </div>
        <div>
          <div class="partTitle" style="margin-top: 20px">心理适应性</div>
          <keep-alive>
            <Xlsyx2 :mind="mind" :result="result"></Xlsyx2>
          </keep-alive>
        </div>
        <div class="buchongs">
            <span :style="{display:show?'':'none'}"></span>
            <a :style="{display:show?'':'none'}">报告解读：</a>
            <div class="textare">
              <el-input
                  placeholder="咨询师解读"
                  :disabled="show"
                  type="textarea"
                  maxlength="200"
                  show-word-limit
                  v-model="xljk" >
              </el-input>
            </div>
        </div>
        <div>
          <div class="partTitle" style="margin-top: 20px;padding-bottom: 0">匹配专业</div>
            <div  v-for="(item,index)  in  professionalRecommend" :key="index">
              <Zyzytj2 :content="item" type="1" :number="''+index" ></Zyzytj2>
              <div class="buchongs" style="margin-top: 0">
                <span :style="{display:show?'':'none'}"></span>
                <a :style="{display:show?'':'none'}">报告解读：</a>
                <div class="textare" v-if="index==0">
                  <el-input
                      placeholder="咨询师解读"
                      :disabled="show"
                      type="textarea"
                      maxlength="200"
                      show-word-limit
                      v-model="zhunyeOne" >
                  </el-input>
                </div>
                <div class="textare" v-if="index==1">
                  <el-input
                      placeholder="咨询师解读"
                      :disabled="show"
                      type="textarea"
                      maxlength="200"
                      show-word-limit
                      v-model="zhunyeTwo" >
                  </el-input>
                </div>
                <div class="textare" v-if="index==2">
                  <el-input
                      placeholder="咨询师解读"
                      :disabled="show"
                      type="textarea"
                      maxlength="200"
                      show-word-limit
                      v-model="zhunyeThree" >
                  </el-input>
                </div>
              </div>
            </div>
        </div>
        <div>
          <div class="partTitle" style="margin-top: 20px;padding-bottom: 0">匹配职业</div>
          <div  v-for="(item,index)  in  careerRecommend"  v-if="index<3" :key="index" >
            <Zyzytj2 :content="item" type="2" :number="''+index" ></Zyzytj2>
            <div class="buchongs" style="margin-top: 0">
              <span :style="{display:show?'':'none'}"></span>
              <a :style="{display:show?'':'none'}">报告解读：</a>
              <div class="textare" v-if="index==0">
                <el-input
                    placeholder="咨询师解读"
                    :disabled="show"
                    type="textarea"
                    maxlength="200"
                    show-word-limit
                    v-model="zhiyeOne" >
                </el-input>
              </div>
              <div class="textare" v-if="index==1">
                <el-input
                    placeholder="咨询师解读"
                    :disabled="show"
                    type="textarea"
                    maxlength="200"
                    show-word-limit
                    v-model="zhiyeTwo" >
                </el-input>
              </div>
              <div class="textare" v-if="index==2">
                <el-input
                    placeholder="咨询师解读"
                    :disabled="show"
                    type="textarea"
                    maxlength="200"
                    show-word-limit
                    v-model="zhiyeThree" >
                </el-input>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div>
          <div class="yixiang">
            <span></span>学生意向:
            <div class="con">
              <div>
                <span>学生向往的职业 :</span>
                {{students.myLikeCareer}}
              </div>
              <div>
                <span>未来想过的生活 :</span>
                {{students.myWantLife}}
              </div>
              <div>
                <span>母亲职业 :</span>
                {{students.motherWork}}
              </div>
              <div>
                <span>父亲职业 :</span>
                {{students.fatherWork}}
              </div>
              <div>
                <span style="position:relative;top:-80px">家长意见 :</span>
                <div class="innerDiv">
                  理想专业（方向）： {{parents.futureMajor}} <br/>
                  理想大学（城市）： {{parents.futureUniversity}}<br/>
                  高考路径 （升学）：{{parents.futureEducation}}
                </div>
              </div>
              <div>
                <span>家长访谈记录 :</span>
                {{interview}}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div style="margin-top: 20px;line-height: 34px" class="changeTj">
            目标专业类（单选）：&nbsp;&nbsp;
            <div style="display: inline-block">
              <el-radio-group v-model="targetCareerFieldZhuanye" :disabled="show">
                <el-radio   :label="item.name"    @click.native.prevent="radioChildZhuanye(index+1,item)" v-for="(item,index) in professionalRecommend" :key="index">{{item.name}}</el-radio>
                <el-radio   label="没有适合的专业"  @click.native.prevent="radioChildZhuanye(4)">没有适合的专业</el-radio>
              </el-radio-group>
              <el-select v-model="selectDataNumberZhuanye" :disabled="show"  v-if="selectBoolZhuanye" @change="selectChangeZhuanye" placeholder="请选择">
                <el-option
                    v-for="(item,key) in careerMajorsZhuanye"
                    :key="item.name"
                    :label="item.name"
                    :value="key">
                </el-option>
              </el-select>
            </div>
          </div>
          <div style="margin-top: 0" class="changeTj">
            目标专业：&nbsp;&nbsp;
            <div style="padding-left: 100px;">
              <el-row>
                <el-col :span="8"  v-for="(item,key) in tuijianDataZhuanye||[]" :key="key">
                  <el-checkbox-group
                  v-model="targetCareerZhuanye"
                  :disabled="show"
                  :max="3">
                <el-checkbox :label="item.name||item.three" >{{item.name||item.three}}</el-checkbox>
              </el-checkbox-group>
                </el-col>
              </el-row>
            </div>
          </div>
          <div style="margin-top: 30px;line-height: 34px" class="changeTj">
            目标职业类（单选）：&nbsp;&nbsp;
            <div style="display: inline-block">
              <el-radio-group v-model="targetCareerFieldZhiye" :disabled="show">
                <el-radio   :label="item.oneItem"    @click.native.prevent="radioChildZhiye(index+1,item)" v-for="(item,index) in careerRecommend" v-if="index<3" :key="index">{{item.oneItem}}</el-radio>
                <el-radio   label="没有适合的职业"  @click.native.prevent="radioChildZhiye(4)">没有适合的职业</el-radio>
              </el-radio-group>
              <el-select v-model="selectDataNumberZhiye"  :disabled="show" v-if="selectBoolZhiye" @change="selectChangeZhiye" placeholder="请选择">
                <el-option
                    v-for="(item,key) in careerMajorsZhiye"
                    :key="item.name"
                    :label="item.name"
                    :value="key">
                </el-option>
              </el-select>
            </div>
          </div>
          <div style="margin-top: 0px" class="changeTj">
            目标职业：&nbsp;&nbsp;
            <div style="padding-left: 100px;">
            <el-row>
              <el-col :span="8" v-for="(item,key) in tuijianDataZhiye||[]" :key="key">
                  <el-checkbox-group
                  v-model="targetCareerZhiye"
                  :disabled="show"
                  :max="3">
                <el-checkbox  :label="item.name||item.two" >{{item.name||item.two}}</el-checkbox>
              </el-checkbox-group>
              </el-col>
            </el-row>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div v-show="!showPartb">
        <ul class="bottom" v-show="!show">
          <div  style="margin:0 auto" class="button hover" @click="preview">预览</div>
        </ul>

        <ul class="bottom" v-show="show">
          <div  class="button hover" @click="show=false,returnTop()">返回修改</div>
          <div  class="button hover" @click="submit()">完成首次访谈</div>
        </ul>
      </div>
      <div v-show="showPartb">
        <ul class="bottom">
          <div  style="margin:0 auto" class="button hover" @click="$router.go(-1)">返回</div>
        </ul>
      </div>
    </div>
    <div v-else class="addBox">
        <div class="add">
            <img src="~@img/xueyezixun/consultant/student/student_add.png" alt="" />
            <p style="text-align: center">暂无生涯解读</p>
        </div>
    </div>
  </div>
</template>

<script>
import Rgtx from '../components/evalutionReport/rgtx'
import Rzqn from '../components/evalutionReport/rzqn'
import Xqqx from '../components/evalutionReport/xqqx'
import Zysy from '../components/evalutionReport/zysy'
import Xljk from '../components/evalutionReport/xljk'
import Zyzytj from '../components/evalutionReport/zyzytj'

import Rgtx2 from '../components/evalutionReport2/rgtx'
import Znsp2 from '../components/evalutionReport2/znsp'
import Xqqx2 from '../components/evalutionReport2/xqqx'
import Zyjzg2 from '../components/evalutionReport2/zyjzg'
import Xlsyx2 from '../components/evalutionReport2/xlsyx'
import Zyzytj2 from '../components/evalutionReport2/zyzytj'

// import firstInterviewPartB2 from "./firstInterviewPartB_2"
export default {
  name: "firstInterviewPartB",
  props:['componentId','componentName'],
  data(){
    return {
      reportId:'',
      version:'',
      rgtx:'',
      rzqn:'',
      xqqx:'',
      zysy:'',
      xljk:'',
      zyzyOne:'',
      zyzyTwo:'',
      zyzyThree:'',

      zhiyeOne:'',
      zhiyeTwo:'',
      zhiyeThree:'',
      zhunyeOne:'',
      zhunyeTwo:'',
      zhunyeThree:'',
      targetCareerFieldZhuanye:'',
      targetCareerFieldZhiye:'',
      targetCareerZhuanye:[],
      targetCareerZhiye:[],
      tuijianDataZhuanye:[],
      tuijianDataZhiye:[],
      careerMajorsZhuanye:[],
      selectBoolZhuanye:false,
      selectDataNumberZhuanye:'',
      selectDataNumberZhiye:'',
      selectDataDataZhuanye:'',
      careerMajorsZhiye:[],
      selectBoolZhiye:false,
      selectDataDataZhiye:'',
      objs:{},
      version:'',
      mbti:{},
      intelligent:[],
      hobby:{},
      profession: {}, //职业倾向
      mind:{},
      result:[],
      professionalRecommend:[],
      careerRecommend:[],

      targetCareerField:'',
      targetCareer:[],
      targetSubject:[],
      best:{},
      second:{},
      third:{},
      parents:{},
      students:{},
      interview:'',
      tuijianData:{},
      careerMajors:[],
      selectBool:false,
      selectDataNumber:'',
      selectDataData:'',
      show:this.$route.query.show=='aa'?true:false,
      showPartb:this.$route.query.show=='aa'?true:false,
      objs:{},
      studentName:'',
    }
  },
  
  components:{Rgtx,Rzqn,Xqqx,Zysy,Xljk,Zyzytj,Rgtx2,Znsp2,Xqqx2,Zyjzg2,Xlsyx2,Zyzytj2},
  created(){
    this.reportId=sessionStorage.getItem('reportId')
     
  },
  methods:{
    toParent(){
      this.$emit('event1','>测评报告解读')
    },
    getReportId(){
      // console.log(this.$route.query.studentId,this.componentId)
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.report.newReportDataJiedu,{
        studentId:this.$route.query.studentId||this.componentId
      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        if(res.data.code==2000){
        
        this.version = res.data.data.career.version
        this.reportId=res.data.data.career.reportId;
        // this.version = 2
        // this.reportId="02b4998babda49d58a0a7bb7c3c6211a";
          if(this.version==2){
            this.getReportData(this.reportId)
            // this.$router.push({
            //   path:'/consultant/newstudent/main/firstInterviewPartB2',query:this.$route.query
            // })
            // window.sessionStorage.setItem('reportId',this.reportId)
          //    this.$router.push({
          //   path:'/consultant/newstudent/main/firstInterviewPartB2',query:this.$route.query
          // })
          window.sessionStorage.setItem('reportId',this.reportId)
          // this.reportId=res.data.data.reportId;
          this.selectBool=true;
          }
         
        }else{
        }
      })
    },
    getTuijianData(obj){
      this.best=obj.best;
      this.second=obj.second;
      this.third=obj.third;
      if(this.showPartb){
        return;
      }
      this.targetCareerField=obj.best.name;
      this.tuijianData=obj.best
    },
    getStudentMessage(){
        this.$ajax.post(this.G_acapi + this.ports.consultant.student.interView.getStudentData,{
          studentId:this.$route.query.studentId||this.componentId
        },{
          headers: {
            token: window.sessionStorage.getItem('ymtxToken')
          }
        }).then(res=>{
          if(res.data.code==2000){
            
            let data=res.data;
            this.parents=data.data.parent.censusQuestion;
            this.students=data.data.student.censusQuestion;
            this.studentName = res.data.data.student.name
          }else{
          }
        })
    },
    getCareerData(){
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.interView.getCareerMajor,{

      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        if(res.data.code==2000){
          this.careerMajors=res.data.data;
          if(this.showPartb){
            if(this.targetCareerField==this.best.name){
              this.tuijianData=this.best
              this.selectBool=false;
              return;
            }
            if(this.targetCareerField==this.second.name){
              this.tuijianData=this.second;
              this.selectBool=false;
              return;
            }
            if(this.targetCareerField==this.third.name){
              this.tuijianData=this.third;
              this.selectBool=false;
              return;
            }
            this.careerMajors.forEach((item,key)=>{
              if(this.targetCareerField == item.name){
                this.selectDataNumber = key
                this.targetCareerField = "没有适合的职业领域"
                this.selectBool=true;
                this.tuijianData={
                  careers:this.careerMajors[key].occupation,
                  majors:this.careerMajors[key].major
                }

              }
            })
          }
        }else{
        }
      })

    },
    radio(value){

    },
    // getData(){
    //   if(this.showPartb){
    //     this.$ajax.post(this.G_acapi + this.ports.consultant.student.interView.detailB,{
    //       studentId:this.$route.query.studentId||this.componentId,
    //     },{
    //       headers: {
    //         token: window.sessionStorage.getItem('ymtxToken')
    //       }
    //     }).then(res=>{
    //       console.log(res)
    //       if(res.data.code==2000){
            
    //         let { rgtx,rzqn,xqqx,zysy,xljk,zyzyOne,
    //           zyzyTwo,zyzyThree,targetCareerField,targetCareer,targetSubject}=res.data.data;
    //         this.rgtx= rgtx;
    //         this.rzqn= rzqn;
    //         this.xqqx= xqqx;
    //         this.zysy= zysy;
    //         this.xljk= xljk;
    //         this.zyzyOne= zyzyOne;
    //         this.zyzyTwo= zyzyTwo;
    //         this.zyzyThree = zyzyThree;
    //         this.targetCareerField=targetCareerField;
    //         this.targetCareer=targetCareer;
    //         this.targetSubject=targetSubject;
    //         this.getCareerData()
    //       }else{
    //       }
    //     })
    //   }else{
    //     this.getCareerData()
    //   }

    // },
       preview(){

      // let { rgtx,rzqn,xqqx,zysy,xljk,zyzyOne,
      //   zyzyTwo,zyzyThree,targetCareerFieldZhuanye,targetCareer,targetSubject}=this;
      // if(!rgtx||!rzqn||!xqqx||!zysy||!xljk||!zyzyOne||!zyzyTwo||!zyzyThree
      //     ||!targetCareerFieldZhuanye|| (targetCareer.length==0)||(targetSubject.length==0)){
      //   this.$message.error('请先完成报告填写。')
      //   return;
      // }
       let { rgtx,rzqn,xqqx,zysy,xljk,zhunyeOne,zhunyeTwo,zhunyeThree,zhiyeOne,
        zhiyeTwo,zhiyeThree,targetCareerFieldZhuanye,targetCareerFieldZhiye,targetCareerZhuanye,targetCareerZhiye}=this;
      if(!rgtx||!rzqn||!xqqx||!zysy||!xljk||!zhunyeOne||!zhunyeTwo||!zhunyeThree||!zhiyeOne||!zhiyeTwo||!zhiyeThree
          ||!targetCareerFieldZhuanye||!targetCareerFieldZhiye||!targetCareerZhiye||!targetCareerZhuanye){
        this.$message.error('请先完成报告填写。')
        return;
      }
      this.show=true
      this.returnTop()
    },
    getInterView(){
      //获取访谈详情
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.interView.detailA, {
        studentId:this.$route.query.studentId||this.componentId,
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res => {
        if (res.data.code == 2000) {
          this.interview=res.data.data.consultantSummary||''
        } else {
        }
      })
    },
    getData(){
      // if(this.showPartb){
        // console.log(this.componentId,this.$route.query.studentId)
        this.$ajax.post(this.G_acapi + this.ports.consultant.student.interView.detailB,{
         // studentId:this.$route.query.studentId||this.componentId||window.sessionStorage.getItem('myStudentStudentId'),
          studentId:window.sessionStorage.getItem('myStudentStudentId')||this.componentId
        },{
          headers: {
            token: window.sessionStorage.getItem('ymtxToken')
          }
        }).then(res=>{
          // console.log(res)
          if(res.data.code==2000){
           
            let { rgtx,rzqn,xqqx,zysy,xljk,zyzyOne,
              zyzyTwo,zyzyThree,careerOne,careerThree,careerTwo,targetCareerField,targetCareer,targetSubject,professional}=res.data.data;
            this.rgtx= rgtx;
            this.rzqn= rzqn;
            this.xqqx= xqqx;
            this.zysy= zysy;
            this.xljk= xljk;
            this.zhiyeOne= careerOne;
            this.zhiyeTwo= careerTwo;
            this.zhiyeThree= careerThree;
            this.zhunyeOne =  zyzyOne;
            this.zhunyeTwo = zyzyTwo;
            this.zhunyeThree = zyzyThree;
            this.zyzyOne = zyzyOne
            this.zyzyTwo= zyzyTwo;
            this.zyzyThree = zyzyThree;
            this.targetCareerZhuanye = targetSubject
            this.targetCareerZhiye = targetCareer
            this.targetCareerField=targetCareerField;

            this.targetCareerFieldZhiye = targetCareerField
            this.targetCareerFieldZhuanye= professional  ;
            
            this.selectDataNumberZhuanye =  professional
            this.selectDataNumberZhiye =targetCareerField
           
            
            
           this.targetCareer=targetCareer;
           this.targetSubject=targetSubject;
           this.getCareerData()
           this.getCareerDataZhuanye()
            this.getCareerDataZhiye()
          }else{
          }
        })
      // }
    },
    radioChild(number){
      if(number==1){
        this.targetCareerField=this.best.name;
        this.tuijianData=this.best;
        this.selectBool=false;
      }
      if(number==2){
        this.targetCareerField=this.second.name;
        this.tuijianData=this.second
        this.selectBool=false;
      }
      if(number==3){
        this.targetCareerField=this.third.name;
        this.tuijianData=this.third;
        this.selectBool=false;
      }
      if(number==4){
        this.targetCareerField='没有适合的职业领域';
        this.selectBool=true;
      }
      this.targetCareer=[];
      this.targetSubject=[];
    },
    selectChange(value){
      this.tuijianData={
        careers:this.careerMajors[value].occupation,
        majors:this.careerMajors[value].major
      }
    },
 

    //新版
     radioChildZhiye(number,item){
      if(number==4){
        this.targetCareerFieldZhiye='没有适合的职业';
        this.selectBoolZhiye=true;
      }else{
        this.targetCareerFieldZhiye=item.oneItem;
        this.tuijianDataZhiye=item.twoItemValue;
        this.selectBoolZhiye=false;
      }
      this.targetCareerZhiye=[];
      this.targetSubjectZhiye=[];
    },
     getCareerDataZhuanye(){
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.report.zhuanyeData,{

      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        if(res.data.code==2000){
          this.careerMajorsZhuanye=res.data.data;
          var bool=true
          if(this.showPartb){
           
            this.professionalRecommend.forEach((item,key)=>{
             
              if(this.targetCareerFieldZhuanye == item.name){

                this.tuijianDataZhuanye = item.professionCode;
                this.selectBoolZhuanye=false;

                bool=false
              }
            })
           
            if(bool){
              this.careerMajorsZhuanye.forEach((item,key)=>{
                
                if(this.targetCareerFieldZhuanye == item.name){
                  this.selectDataNumber = key
                  this.selectBoolZhuanye=true;
                 this.targetCareerFieldZhuanye = "没有适合的专业"
                  this.tuijianDataZhuanye = item.child
                }
              })
            }
          }
        }else{
        }
      })

    },
    getCareerDataZhiye(){
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.report.zhiyeData,{

      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        if(res.data.code==2000){
          this.careerMajorsZhiye=res.data.data;
          let bool=true
          if(this.showPartb){
            
            this.careerRecommend.forEach((item,key)=>{
              if(this.targetCareerFieldZhiye == item.oneItem){
                this.tuijianDataZhiye = item.twoItemValue;
                this.selectBoolZhiye=false;
                bool=false;
              }
            })
            if(bool){
              this.careerMajorsZhiye.forEach((item,key)=>{
                if(this.targetCareerFieldZhiye == item.name){
                  this.selectDataNumber = key
                  this.selectBoolZhiye=true;
                  this.targetCareerFieldZhiye = "没有适合的职业"
                  this.tuijianDataZhiye = item.child
                }
              })
            }else{
              this.careerMajorsZhuanye.forEach((item,key)=>{
                
                if(this.targetCareerFieldZhuanye == item.name){
                  this.selectDataNumber = key
                  this.selectBoolZhuanye=true;
                 this.targetCareerFieldZhuanye = "没有适合的专业"
                  this.tuijianDataZhuanye = item.child
                }
              })
            }
          }
        }else{
        }
      })

    },
      radioChildZhuanye(number,item){
      if(number==4){
        this.targetCareerFieldZhuanye='没有适合的专业';
        this.selectBoolZhuanye=true;
      }else{
        this.targetCareerFieldZhuanye=item.name;
        this.tuijianDataZhuanye=item.professionCode;
        this.selectBoolZhuanye=false;
      }
      this.targetCareerZhuanye=[];
      this.targetSubjectZhuanye=[];
    },
    selectChangeZhuanye(value){
      this.tuijianDataZhuanye=this.careerMajorsZhuanye[value]['child']
      
    },
    selectChangeZhiye(value){
      this.tuijianDataZhiye=this.careerMajorsZhiye[value]['child']
    },
    getReportData(id){
      this.$ajax.post(this.G_capi + this.ports.consultant.student.report.newReportData,{
        reportId: id,
      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        
        if(res.data.code==2000){
          this.mbti = res.data.data.mbti; //人格特性
          this.intelligent = res.data.data.intelligent; //智能水平
          this.hobby = res.data.data.hobby; //兴趣倾向
          this.profession = res.data.data.profession; //职业价值观
          this.mind = res.data.data.mind; //心里适应性
          this.result = res.data.data.mind.result
          this.professionalRecommend=res.data.data.professionalRecommend
          this.careerRecommend=res.data.data.careerRecommend
          this.getData()
          // if(this.showPartb){
          //   return
          // }
          this.targetCareerFieldZhuanye=this.professionalRecommend[0]&&this.professionalRecommend[0].name;
          this.tuijianDataZhuanye=this.professionalRecommend[0]&&this.professionalRecommend[0]['professionCode']

          this.targetCareerFieldZhiye=this.careerRecommend[0]&&this.careerRecommend[0].oneItem;
          this.tuijianDataZhiye=this.careerRecommend[0]&&this.careerRecommend[0]['twoItemValue']
        }else{
        }
      })
    },

  }
  ,mounted() {

    if(this.componentId){
      this.show=true;
      this.showPartb=true
    }

    this.toParent()
    this.getReportId()
    this.getData();
    this.getStudentMessage();
    this.getInterView()
    
  }
}
</script>

<style  lang="less" scoped>
.addBox {
    min-height: 600px;
    padding-top: 80px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    background: #fff;
    .add {
        cursor: pointer;
        img {
            margin-bottom: 20px;
            display: block;
            margin: 0 auto;
        }
        p {
            line-height: 30px;
            font-size: 16px;
            span {
                color: #2BA6EE;
                cursor: pointer;
            }
        }
    }
}
.evaluationPeport_main{
  // width: 1050px;
  margin:0 auto;
  background: #fff;
  padding: 20px 90px  50px;
  .title{
    font-size: 32px;
    font-weight: bolder;
    line-height: 80px;
    text-align: center;
    color:#0094EA;
  }
  .partTitle{
    font-size: 20px;
    color:#2F2F2F;
    font-weight: bolder;
    padding: 30px 0 ;
  }
  .evaluation_button{
    width: 74px;
    margin: 0 auto;
    border-radius: 16px;
    text-align: center;
    line-height: 32px;
    font-size: 16px;
    cursor: pointer;
    background: #ECF8FE;
    color: #1EA2EE;
    border: 1px solid #76C6F4;
    padding: 0 20px;
    &:hover{
      background: #099BEF !important;
      color: #fff !important;
    }
  }

}

.firstInterviewPartB{
  padding-bottom: 40px;
  .buchongs{
    margin-top: 40px;
    textarea{
      min-height: 140px;
    }
  }
  .yixiang{
    margin-top: 30px;
    &>span{
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background:#00A7FF;
      margin-right: 10px;
    }
    font-size: 18px;
    div{
      font-size: 16px;
    }
    .con{
      margin-top: 10px;
      padding: 15px;
      background: #F1FBFD;
      line-height: 40px;
      span{
        font-size: 16px;
        font-weight: normal;
        width: 150px;
        display: inline-block;
      }
    }
    .innerDiv{
      display:inline-block;
      font-size: 16px;
      position: relative;
    }
    .changeTj{
      font-size: 14px;
    }

  }
  .changeTj{
    font-size: 16px;
    &>div{
      margin-bottom: 20px;
    }
    .checkbox{
      display: block;
      padding-left: 120px;
      line-height: 30px;
      margin-left: 0;
    }
  }
  .buttons{
    width: 418px;
    margin: 40px auto;
    display: flex;
    justify-content: space-between;
  }
  .button{
    border-radius: 16px;
    text-align: center;
    line-height: 32px;
    font-size: 16px;
    cursor: pointer;
    background: #ECF8FE;
    color: #1EA2EE;
    border: 1px solid #76C6F4;
    display: inline-block;
    padding: 0 20px;
  }
  .buttons{
    width: 418px;
    margin: 40px auto;
    display: flex;
    justify-content: space-between;
  }
  .bottom{
    width: 400px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
    li{
      width: 128px;
      height: 32px;
      line-height: 32px;
      background: #C8C6C6;
      box-shadow: 0px 4px 6px 0px rgba(196, 196, 196, 0.4);
      border-radius: 15px;
      text-align: center;
      font-size: 18px;
      color: #fff;
      cursor: pointer;
    }
    .newActive{
      color:#fff;
      background:#0094EA;
    }
  }
  .hover{
    cursor: pointer;
    &:hover{
      background: #099BEF !important;
      color: #fff !important;
    }
  }
}
</style>
<style lang="less">
.firstInterviewPartB{
  *{
    font-size: 14px;
  }
  .title{
    .title{
      font-size: 18px;
      font-weight: normal;
    }
  }
  .textare{
    margin-top: 20px;
    textarea {
      min-height: 96px !important;
      font-size: 14px
    }
  }
  .buchongs {
    textarea {
      min-height: 140px !important;
    }
  }
  .el-input--suffix{
    width: 120px;
    border: 1px solid #DCDFE6;
  }
  .el-input__inner{
    line-height: 32px;
    height: 32px;
  }
   .el-icon-arrow-up{
     line-height: 32px;
   }
   .el-radio{
     margin-right: 10px;
   }
  .el-checkbox-group{
    label{
      display: block;
      margin-top: 14px;
    }
    *{
      font-size: 14px;
    }

  }
}
</style>